import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { Segments } from '@/components/kit/Layout';
import { PageHeader } from '@/components/kit/Layout';

const TABS = [
  { to: '/crm/leads', label: 'Заявки' },
  { to: '/crm/deals', label: 'Сделки' },
  { to: '/crm/settings', label: 'Настройки' },
] as const;

/**
 * Шапка раздела CRM: заголовок с главной кнопкой и вкладки «Заявки ·
 * Сделки · Настройки» (crmTabs в макете). Вкладки переключают раздел —
 * подчёркиванием, под шапкой экрана (кит, «Вкладки и сегменты»).
 */
export function CrmHeader({ current, action }: { current: (typeof TABS)[number]['to']; action?: ReactNode }) {
  const navigate = useNavigate();
  return (
    <>
      <PageHeader title="CRM">{action}</PageHeader>
      <div className="tabs">
        {TABS.map((t) => (
          <div key={t.to} className={t.to === current ? 'tab on' : 'tab'} onClick={() => navigate(t.to)}>
            {t.label}
          </div>
        ))}
      </div>
    </>
  );
}

export type ViewMode = 'list' | 'board';

/**
 * Шапка раздела `.segbar`: срез слева, «Список / Доска» справа.
 * Переключатель вида — не фильтр: он меняет то, как показан список,
 * поэтому стоит в шапке раздела, а не в ряду фильтров (кит п. 19).
 */
export function SectionBar({
  left,
  mode,
  onMode,
}: {
  left?: ReactNode;
  mode: ViewMode;
  onMode: (mode: ViewMode) => void;
}) {
  return (
    <div className={left ? 'segbar' : 'segbar noseg'}>
      {left}
      <div className="sp" />
      <Segments
        value={mode}
        onChange={onMode}
        items={[
          { value: 'list', label: 'Список' },
          { value: 'board', label: 'Доска' },
        ]}
      />
    </div>
  );
}
